import React from "react";

const FullLoader = () => {
  return (
    <div className="fullpage-loader">
      <div className="spinner"></div>
    </div>
  );
};

export default FullLoader;
